import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom';

import { connect } from 'react-redux';
import * as actions from '../../../actions';
import classes  from '../../../utils/cssClasses';

class BadgeClassList extends Component{
	
	constructor(props) {
	  super(props);
	  this.tags = React.createRef();
	  this.handleSearch = this.handleSearch.bind(this)
	}

	componentDidMount(){
		this.props.fetchBadgeClasses();
	}

	handleSearch(e)  {
		e.preventDefault()
		this.props.fetchBadgeClasses({
			tags: this.tags.current.value
		});
	}

	renderTable(badgeClasses) {
		return (
			
			<table className={classes('table')}>
				<thead className={classes('thead-dark')}>
					<tr>
						<th>Name</th>
						<th>Assignee</th>
						<th>Actions</th>
					</tr>
				</thead>
				<tbody>
					{badgeClasses.map(badgeClass => {
						return(
								<tr key={badgeClass._id}>
									<td>
										<Link to={`/admin/badgeclasses/${badgeClass._id}`}>{badgeClass.name}</Link>
									</td>
									<td>
										{badgeClass.assertion_count}
									</td>
									<td>
										<Link to={`/admin/badgeclasses/${badgeClass._id}/assertion`}>Assegna</Link>
									</td>
								</tr>
							);
					})}
				</tbody>
			</table>
		)
	}

	render(){
		const { badgeClasses } = this.props;

		if (!badgeClasses){
			return ( 
				<FontAwesomeIcon icon="spinner" spin  />
			 );
		}
		// console.log(badgeClasses)
		return (
			<div>
				<p className={classes('text-sm text-muted mb-0')}> Puoi cercare per tag, separandoli con una virgola</p>
				<form onSubmit={this.handleSearch} className={classes("row mb-3 mt-1")}>
					<div className={classes("col")}>
						<input className={classes("form-control")} ref={this.tags}/>
					</div>
					<div className={classes("col-auto")}>
						<button className={classes("btn btn-primary")}>Cerca</button>
					</div>
				</form>

				
				{ badgeClasses.length ?  this.renderTable(badgeClasses) : (
					<p>Nessun Badge trovato</p>
				)}
			</div>
		);
	}
}

function mapStateToProps({ badgeClasses }){
	return { badgeClasses };
}

export default connect(mapStateToProps,actions)(BadgeClassList);


// WEBPACK FOOTER //
// ./src/components/Backend/BadgeClassList/BadgeClassList.js